@if (loading) {
  <w-dialog [style]="style">
    <w-step title="Error!" [reviewMode]="true">
      <div facet-step-info [innerHTML]="message">{{message | translate }}</div>
      <button w-button (click)="closeDialogbox()" facet-step-actions>OK</button>
    </w-step>
  </w-dialog>
}